"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigTabLayout = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const BigTabLayoutStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ $isDesktop }) => (!$isDesktop ? '0px' : '20px')};

	.big-tab-layout-header {
		width: 100%;
		overflow: hidden;
		padding: ${({ $isDesktop }) => (!$isDesktop ? '20px 20px 0 20px' : '0')};
	}

	.big-tab-layout-list {
		display: flex;
		align-items: center;
		gap: 0;
		width: 100%;
		border-bottom: ${({ $isMobile }) => ($isMobile ? '1px solid #c6c8ce' : '1px solid #454552')};
	}

	.big-tab-layout-btn {
		border: 1px solid #c6c8ce;
		border-bottom-color: transparent;
		background: #ffffff;
		color: #7b7d84;
		padding: ${({ $isMobile }) => ($isMobile ? '10px 0' : '12px 68px')};
		margin-bottom: -1px;
		border-radius: 8px 8px 0 0;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${({ $isMobile }) => ($isMobile ? '15px' : 'var(--h5-font-size, 16px)')};
		line-height: ${({ $isMobile }) => ($isMobile ? '22px' : 'var(--h5-line-height, 24px)')};
		font-weight: 700;
		white-space: nowrap;
		cursor: pointer;
		flex: ${({ $isMobile }) => ($isMobile ? '1' : 'unset')};
		min-width: ${({ $isMobile }) => ($isMobile ? '0' : 'unset')};
		position: relative;
		z-index: 1;
	}

	.big-tab-layout-btn.active {
		color: #101010;
		border-width: 1.5px;
		border-color: #454552;
		border-bottom-color: ${({ $isMobile }) => ($isMobile ? 'transparent' : '#ffffff')};
		z-index: 2;
	}

	.big-tab-layout-btn:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}

	.big-tab-layout-content {
		width: 100%;
	}

	.big-tab-layout-pane.hidden {
		display: none;
	}

	.big-tab-layout-btn + .big-tab-layout-btn {
		margin-left: -1px;
	}
`;
exports.BigTabLayout = react_1.default.memo(({ tabs, defaultTabId, activeTabId, onTabChange, className, keepMounted = false, }) => {
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const firstTabId = tabs[0]?.id;
    const [internalTabId, setInternalTabId] = react_1.default.useState(defaultTabId || firstTabId);
    react_1.default.useEffect(() => {
        if (!defaultTabId)
            return;
        setInternalTabId(defaultTabId);
    }, [defaultTabId]);
    react_1.default.useEffect(() => {
        if (!tabs.some(tab => tab.id === internalTabId) && firstTabId) {
            setInternalTabId(firstTabId);
        }
    }, [tabs, internalTabId, firstTabId]);
    const currentTabId = activeTabId ?? internalTabId;
    const changeTab = (tabId) => {
        if (activeTabId === undefined) {
            setInternalTabId(tabId);
        }
        onTabChange?.(tabId);
    };
    const activeTab = tabs.find(tab => tab.id === currentTabId) || tabs[0];
    return (react_1.default.createElement(BigTabLayoutStyled, { className: className, "$isMobile": isMobile, "$isDesktop": isDesktop },
        react_1.default.createElement("div", { className: "big-tab-layout-header" },
            react_1.default.createElement("div", { className: "big-tab-layout-list", role: "tablist" }, tabs.map(tab => (react_1.default.createElement("button", { key: tab.id, type: "button", className: `big-tab-layout-btn ${currentTabId === tab.id ? 'active' : ''}`.trim(), onClick: () => changeTab(tab.id), disabled: tab.disabled, role: "tab", "aria-selected": currentTabId === tab.id }, tab.title))))),
        react_1.default.createElement("div", { className: "big-tab-layout-content" }, keepMounted
            ? tabs.map(tab => (react_1.default.createElement("div", { key: tab.id, className: `big-tab-layout-pane ${currentTabId === tab.id ? '' : 'hidden'}`.trim() }, tab.content)))
            : activeTab?.content)));
});
